module.exports = __webpack_public_path__ + "img/xml.358fd24b.svg";